











































import Vue, { VueConstructor } from "vue";
import anime from "animejs";

import TagValue from "./TagValue.vue";
import DateValue from "./DateValue.vue";

import { IFilter, IFilterValue } from "../store/state";
import { setFilterOpen, toggleFilterValue } from "../store/actions";

const valueTypes = {
  tags: TagValue,
  dates: DateValue
} as any;

interface IBloglistFilterProps extends IFilter {
  displayName: string;
  name: string;
}

interface IBloglistFilterMethods {
  toggleValue(value: IFilterValue): void;
  toggleFilter(): void;
  closeFilter(): void;
  beforeOpen(el: HTMLElement): void;
  animateOpen(el: HTMLElement, done: any): void;
  animateClose(el: HTMLElement, done: any): void;
  toggleOpenValue(year: number): void;
  valueOpen(year: number): boolean;
}

interface IBloglistFilterComputed {
  openClass: any;
  filterComponent: VueConstructor;
}

interface IBloglistFilterData {
  openValue: number;
}

export default Vue.extend<
  IBloglistFilterData,
  IBloglistFilterMethods,
  IBloglistFilterComputed,
  IBloglistFilterProps
>({
  props: {
    open: Boolean,
    name: String,
    displayName: String,
    values: Array
  },
  data() {
    return {
      openValue: -1
    };
  },
  computed: {
    openClass() {
      return {
        "kb-bloglist-filter--open": this.open
      };
    },
    filterComponent() {
      return valueTypes[this.name];
    }
  },
  methods: {
    toggleOpenValue(year) {
      if (this.name === "dates") {
        if (this.openValue == year) {
          this.openValue = -1;
        } else {
          this.openValue = year;
        }
      }
    },
    valueOpen(year) {
      if (this.name === "dates") {
        return this.openValue == year;
      }
      return false;
    },
    toggleValue(value) {
      this.$store.dispatch(
        toggleFilterValue({
          name: this.name,
          value
        })
      );
    },
    toggleFilter() {
      this.$store.dispatch(
        setFilterOpen({
          name: this.name,
          open: !this.open
        })
      );
    },
    closeFilter() {
      this.$store.dispatch(
        setFilterOpen({
          name: this.name,
          open: false
        })
      );
    },
    beforeOpen(el) {},
    animateOpen(el, done) {
      anime({
        targets: el,
        height: [0, el.offsetHeight],
        duration: 250,
        elasticity: 0,
        easing: "linear",
        complete: () => {
          el.style.height = "";

          const firstInput = (this.$refs.filter as Element).querySelector(
            "label"
          );
          if (firstInput) {
            (firstInput as HTMLElement).focus();
          }
          done();
        }
      });
    },
    animateClose(el, done) {
      anime({
        targets: el,
        height: [el.offsetHeight, 0],
        duration: 250,
        elasticity: 0,
        easing: "linear",
        complete: () => {
          el.style.height = "";
          done();
        }
      });
    }
  },
  components: {
    TagValue,
    DateValue
  }
});
